module.exports = __webpack_public_path__ + "img/appscrn_2_avatar.a3e5c969.png";